import MinimumValueErrorLabel from '../labels/MinimumValueErrorLabel';
import useCheckoutThreshold from '../../hooks/order/useCheckoutThreshold';
import { useTranslation } from 'react-i18next';
import useAppMethods from '../../hooks/utility/useAppMethods';

interface Props {
  className?: string;
}

export default function CheckoutThreshold(props: Props) {
  const { t } = useTranslation(null, { keyPrefix: 'Components:Checkout:CheckoutThreshold' });

  const { className } = props;

  const { formatCurrency } = useAppMethods();
  const { hasReachedCheckoutThreshold } = useCheckoutThreshold();

  return (
    !hasReachedCheckoutThreshold && (
      <div className={className}>
        <MinimumValueErrorLabel
          description={t('title', {
            rangeStart: formatCurrency(0.01),
            rangeEnd: formatCurrency(0.99),
          })}
          value={formatCurrency(1)}
          type="Notice"
        />
        <p className="mt-xs text-xs">
          {t('description', {
            amount: formatCurrency(0),
          })}
        </p>
      </div>
    )
  );
}
